import { SettingValueType } from '@/enums/settingValueType.enum';
import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    code: {
      title: 'Kod',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'Opis',
      type: 'string',
      fieldRequired: false
    },
    entityType: {
      title: 'Typ Encji',
      type: 'string',
      fieldRequired: false
    },
    entityId: {
      title: 'Identyfikator encji',
      type: 'string',
      fieldRequired: false
    },
    value: {
      title: 'Wartość',
      type: 'string',
      fieldRequired: true,
      calc: {
        when: `this.valueType === '${SettingValueType.DATE}' && this.date`,
        func: 'this.date'
      },
      validFunc: [
        `if (this.valueType !== '${SettingValueType.VALORIZATION_INDEX}') {`,
        '  return true;',
        '}',
        'var value = parseFloat(this.value);',
        'if (!value || value < 100) {',
        '  return "Wartość musi być liczbą. Minimalna wartość to 100.";',
        '}'
      ]
    },
    date: {
      calc: {
        when: `this.valueType === '${SettingValueType.DATE}' && !this.date`,
        func: 'this.value'
      },
      computed: true,
      fieldRequired: `this.valueType === '${SettingValueType.DATE}'`,
      format: 'date',
      title: 'Wartość',
      type: 'string'
    },
    valueType: {
      title: 'Typ wartości',
      type: 'string',
      fieldRequired: false
    },
    groupId: {
      title: 'Identyfikator grupy',
      type: 'number',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
